import { getMyGemService } from "@/services";
export const fetch = {
  namespaced: true,
  state: {
    parentDomain: null,
    entities: [],
    loadingStatus: false,
    types: {
      employee: {
        type: {},
        category: {},
      },
      vendor: {
        type: {},
        category: {},
      },
      customer: {
        type: {},
        category: {},
      },
    },
  },
  actions: {
    async fetch({ commit }, { serviceId, data }) {
      let service = getMyGemService(serviceId);
      return await service.all(data).then(
        (payload) => {
          commit("FETCH", { payload, service });
          commit("loadingStatus", true);
          return Promise.resolve(payload);
        },
        (error) => {
          commit("FETCH");
          return Promise.reject(error);
        }
      );
    },
    async refresh({ state, dispatch }, { serviceId, data }) {
      await dispatch("fetch", {
        serviceId,
        data,
      });
      return Promise.resolve(state.entities);
    },
  },
  mutations: {
    FETCH(state, data) {
      if (data) {
        state.entities[data.service.DOMAIN] = data.payload;
      }
    },
    loadingStatus(state, newLoadingStatus) {
      state.loadingStatus = newLoadingStatus;
    },
    domain(state, data) {
      state.parentDomain = data.parentDomain;
    },
  },
};
